import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage, getEquivalentRoute } from '../context/LanguageContext';

const SEOHead = ({ title, description }) => {
  const location = useLocation();
  const { language } = useLanguage();
  
  const baseUrl = 'https://savoir-faire-design.preview.emergentagent.com';
  
  useEffect(() => {
    // Set document title
    document.title = title;
    
    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);
    
    // Remove existing hreflang tags
    document.querySelectorAll('link[hreflang]').forEach(el => el.remove());
    document.querySelectorAll('link[rel="canonical"]').forEach(el => el.remove());
    
    // Current URL
    const currentUrl = `${baseUrl}${location.pathname}`;
    
    // Get equivalent URLs for both languages
    const enUrl = `${baseUrl}${getEquivalentRoute(location.pathname, 'en')}`;
    const frUrl = `${baseUrl}${getEquivalentRoute(location.pathname, 'fr')}`;
    
    // Add canonical URL
    const canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', currentUrl);
    document.head.appendChild(canonical);
    
    // Add hreflang for English
    const hreflangEn = document.createElement('link');
    hreflangEn.setAttribute('rel', 'alternate');
    hreflangEn.setAttribute('hreflang', 'en');
    hreflangEn.setAttribute('href', enUrl);
    document.head.appendChild(hreflangEn);
    
    // Add hreflang for French
    const hreflangFr = document.createElement('link');
    hreflangFr.setAttribute('rel', 'alternate');
    hreflangFr.setAttribute('hreflang', 'fr');
    hreflangFr.setAttribute('href', frUrl);
    document.head.appendChild(hreflangFr);
    
    // Add x-default (pointing to English as default)
    const hreflangDefault = document.createElement('link');
    hreflangDefault.setAttribute('rel', 'alternate');
    hreflangDefault.setAttribute('hreflang', 'x-default');
    hreflangDefault.setAttribute('href', enUrl);
    document.head.appendChild(hreflangDefault);
    
    // Set html lang attribute
    document.documentElement.setAttribute('lang', language);
    
    return () => {
      // Cleanup on unmount
      document.querySelectorAll('link[hreflang]').forEach(el => el.remove());
      document.querySelectorAll('link[rel="canonical"]').forEach(el => el.remove());
    };
  }, [title, description, location.pathname, language]);
  
  return null;
};

export default SEOHead;
